var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicinesMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2938_18549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.385 6.39664C19.7286 6.49332 20.0712 6.23092 20.1501 5.81054C20.2291 5.39023 20.0146 4.97109 19.671 4.87449L15.448 3.68673C15.1044 3.59005 14.7619 3.85245 14.6829 4.27284C14.6039 4.69315 14.8184 5.11229 15.1619 5.20889L19.385 6.39664Z",
    fill: "#AB9D96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9582 10.0833C19.7426 10.0833 21.9998 7.82612 21.9998 5.04167C21.9998 2.25723 19.7426 0 16.9582 0C14.1737 0 11.9165 2.25723 11.9165 5.04167C11.9165 7.82612 14.1737 10.0833 16.9582 10.0833ZM16.9582 8.82292C19.0465 8.82292 20.7394 7.12999 20.7394 5.04167C20.7394 2.95335 19.0465 1.26042 16.9582 1.26042C14.8698 1.26042 13.1769 2.95335 13.1769 5.04167C13.1769 7.12999 14.8698 8.82292 16.9582 8.82292Z",
    fill: "#AB9D96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79252 1.7014C6.38446 0.736039 5.0198 0.638666 4.47165 1.53579L0.184533 8.55152C-0.310005 9.36083 0.242928 10.3941 1.20742 10.4629L8.68573 10.9965C9.6502 11.0653 10.3519 10.1216 9.98376 9.25073L6.79252 1.7014ZM5.55252 2.18529C5.55157 2.18643 5.54968 2.18882 5.54716 2.19298L1.26672 9.19786L1.2677 9.19855C1.26893 9.19937 1.27087 9.20044 1.27423 9.20158C1.2774 9.20271 1.28454 9.20473 1.29712 9.20561L8.7754 9.7392C8.78801 9.74015 8.7957 9.73914 8.7996 9.73839C8.80376 9.73763 8.80666 9.73656 8.80899 9.73542C8.81202 9.73404 8.81504 9.73202 8.81775 9.72956L5.63161 2.19216C5.63041 2.18933 5.6294 2.18744 5.62877 2.18624C5.62505 2.1841 5.61371 2.17874 5.59493 2.17735C5.57413 2.1759 5.56021 2.1805 5.55567 2.18271L5.55416 2.18359L5.55346 2.18422L5.55252 2.18529Z",
    fill: "#AB9D96"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0836 18.6722C19.8885 17.8452 20.6695 15.737 19.8278 13.9634C18.9861 12.1898 16.8406 11.4225 15.0357 12.2495L8.49943 15.2445C6.69445 16.0715 5.91357 18.1797 6.75521 19.9533C7.59691 21.7269 9.74235 22.4942 11.5473 21.6672L18.0836 18.6722ZM9.00739 16.3149C7.80407 16.8663 7.28349 18.2718 7.84458 19.4541C8.40573 20.6365 9.83605 21.1481 11.0394 20.5967L13.7234 19.3668L11.6917 15.0855L9.00739 16.3149ZM14.8128 18.8677L12.7809 14.5859L15.5437 13.32C16.747 12.7686 18.1773 13.2801 18.7384 14.4626C19.2995 15.6449 18.7789 17.0504 17.5756 17.6018L14.8128 18.8677Z",
    fill: "#AB9D96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2938_18549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicinesMenu);
export default __webpack_public_path__ + "static/media/medicines-menu.9158e1e7ee276aff2a2c4bac55be55a8.svg";
export { ForwardRef as ReactComponent };